export default function () {
  return {
    // Excluded tags keyed by license ID: { [licenseId]: ['TAG1', 'TAG2', ...] }
    excludedTags: {},
    // Full records for management page
    excludedPackages: [],
    // Loading state
    loading: false,
  };
}
